import { useState, useEffect } from "react";
import iconClose from "../../assets/icon-close.svg";

interface ButtonSettingsPanelProps {
  open: boolean;
  initialText: string;
  initialLink: string;
  onSave: (text: string, link: string) => void;
  onClose: () => void;
}

export function ButtonSettingsPanel({
  open,
  initialText,
  initialLink,
  onSave,
  onClose,
}: ButtonSettingsPanelProps) {
  const [text, setText] = useState(initialText);
  const [link, setLink] = useState(initialLink);

  useEffect(() => {
    setText(initialText);
    setLink(initialLink);
  }, [initialText, initialLink]);

  const canSave = text.trim().length > 0 && /^https?:\/\//i.test(link.trim());

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-overlay" role="button" tabIndex={-1} onClick={onClose} onKeyDown={(e) => { if (e.key === "Escape") onClose(); }} />
      <div className="relative w-[480px] h-full bg-bg-primary shadow-lg flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-stroke-primary">
          <h3 className="text-xl font-semibold text-text-primary">Button Settings</h3>
          <button onClick={onClose} aria-label="Close">
            <img src={iconClose} alt="" width={24} height={24} />
          </button>
        </div>
        <div className="flex-1 p-5 flex flex-col gap-4">
          <div>
            <label className="text-sm font-medium text-text-primary mb-1 block">Text</label>
            <input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Button text"
              className="w-full h-[51px] px-4 rounded-2xl border border-stroke-primary text-base text-text-primary placeholder:text-text-tertiary focus:outline-none focus:border-brand-brown"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-text-primary mb-1 block">Link To</label>
            <input
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="https://"
              className="w-full h-[51px] px-4 rounded-2xl border border-stroke-primary text-base text-text-primary placeholder:text-text-tertiary focus:outline-none focus:border-brand-brown"
            />
          </div>
        </div>
        <div className="p-5 border-t border-stroke-primary">
          <button
            type="button"
            disabled={!canSave}
            onClick={() => onSave(text.trim(), link.trim())}
            className={`w-full h-[51px] rounded-2xl text-base font-semibold ${
              canSave
                ? "bg-btn-primary text-text-btn"
                : "bg-btn-primary-disabled text-text-btn cursor-not-allowed"
            }`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
